import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, map, retry } from 'rxjs';

const PDF_SERVICES_URL = environment.pdfservices_url;
const CLIENT_ID = environment.pdfservices_clientId;
const CLIENT_SECRET = environment.pdfservices_clientSecret;


@Injectable({
    providedIn: 'root'
})
export class PdfServicesService {

    constructor(
        private http: HttpClient
    ) { }

    getAccessToken(): Observable<string> {

        const url = `${PDF_SERVICES_URL}/token`;

        const body = new URLSearchParams();
        body.set('client_id', CLIENT_ID);
        body.set('client_secret', CLIENT_SECRET);

        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        return this.http.post<any>(url, body.toString(), { headers })
            .pipe(
                map(resp => resp.access_token),
            )
    }

    getAuthHeaders(token: string): HttpHeaders {
        return new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-api-key': CLIENT_ID
        });
    }

    getUploadPreSignedUri(token: string): Observable<any> {

        const url = `${PDF_SERVICES_URL}/assets`;

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-api-key': CLIENT_ID
        })

        const body = {
            mediaType: 'application/pdf'
        }

        return this.http.post<any>(url, body, { headers })
    }

    uploadFileToPresignedUri(preSignedUri: string, file: File): Observable<any> {

        const url = `${preSignedUri}`;

        return this.http.put<any>(url, file)
    }

    getDownloadPreSignedUri(assetId: string, token: string): Observable<any> {

        const url = `${PDF_SERVICES_URL}/assets/${assetId}`;

        return this.http.get<any>(url, { headers: this.getAuthHeaders(token) })
    }

    importPdfFormData(assetId: string, jsonFormFields, token: string): Observable<any> {

        const url = `${PDF_SERVICES_URL}/operation/setformdata`;

        const body = {
            assetID: assetId,
            jsonFormFieldsData: jsonFormFields
        }

        return this.http.post<any>(url, body, { headers: this.getAuthHeaders(token) })
    }

    exportPdfFormData(assetId: string, token: string): Observable<any> {
        const url = `${PDF_SERVICES_URL}/operation/getformdata`;

        const body = {
            assetID: assetId
        };

        return this.http.post<any>(url, body, { headers: this.getAuthHeaders(token), observe: 'response' });
    }

}
